import React, { useContext } from 'react';
import { LoadingIndicator, Loading } from '@monash/portal-react';
import { RenderAnimation } from '@monash/portal-frontend-common';
import c from './profile.module.scss';
import About from './about/About';
import backgroundAnimation from '../../../assets/lotties/profile-background-final.json';
import Header from './header/Header';
import { StudentContext } from '../../providers/StudentProvider';
import PageContainer from '../../ui/page-container/PageContainer';
import MPass from './m-pass/MPass';

const Profile = () => {
  const { profileData, loadingProfileData } = useContext(StudentContext);

  return (
    <>
      <PageContainer>
        <Loading
          isLoading={loadingProfileData}
          loadingMsg="Loading profile"
          loadingPage={
            // TODO: refactor and use page container component instead
            // TODO: update loading indicator component and pass message in as a prop
            <div className={c.loadingScreen}>
              <LoadingIndicator />
              <p>Loading profile</p>
            </div>
          }
        >
          {profileData && (
            <div className={c.profile}>
              <div
                className={c.profileContent}
                role="region"
                aria-label="Profile"
              >
                <Header />
                <section
                  className={c.studentInfo}
                  aria-label="Personal information"
                >
                  <div className={c.contentContainer}>
                    <About />
                    <MPass />
                  </div>
                </section>
              </div>
            </div>
          )}
        </Loading>
      </PageContainer>

      <div className={c.background}>
        <RenderAnimation
          className={c.animation}
          lottieFile={backgroundAnimation}
          aspectRatio="xMidYMax"
        />
      </div>
    </>
  );
};

export default Profile;
